import { Button } from "@/components/ui/button";
import ImageSvg from "@/components/ui/image-svg";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/use-toast";
import { authenticateRecovery } from "@/services/clientAreaService";
import { ArrowRight, Loader2 } from "lucide-react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function VerifyRecoveryCode() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { email = "" } = useParams();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!code) {
      toast({
        title: "Erro",
        description: "Preencha o código de verificação.",
        variant: "destructive",
        style: {
          position: "fixed",
          top: 24,
          right: 24,
          zIndex: 9999,
          maxWidth: 400,
          width: "100%",
        },
      });
      return;
    }
    setLoading(true);
    try {
      const response = await authenticateRecovery(email, code);
      if (response?.user) {
        toast({
          title: "Sucesso!",
          description: "Código verificado com sucesso.",
          variant: "green",
          style: {
            position: "fixed",
            top: 24,
            right: 24,
            zIndex: 9999,
            maxWidth: 400,
            width: "100%",
          },
        });
        navigate(
          `/esqueci-senha/criar-nova-senha/${encodeURIComponent(
            email
          )}/${encodeURIComponent(code)}`
        );
      } else {
        toast({
          title: "Erro",
          description:
            response?.mensagem || "Código incorreto! Tente novamente.",
          variant: "destructive",
          style: {
            position: "fixed",
            top: 24,
            right: 24,
            zIndex: 9999,
            maxWidth: 400,
            width: "100%",
          },
        });
      }
    } catch (error: unknown) {
      const err = error as { response?: { data?: { mensagem?: string } } };
      toast({
        title: "Erro",
        description:
          err?.response?.data?.mensagem || "Erro ao verificar código.",
        variant: "destructive",
        style: {
          position: "fixed",
          top: 24,
          right: 24,
          zIndex: 9999,
          maxWidth: 400,
          width: "100%",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen px-5 py-10 md:px-10 md:py-20">
      <div className="flex flex-col md:flex-row items-center justify-center gap-10">
        {/* Card */}
        <div className="bg-white max-w-[600px] rounded-[20px] w-full md:w-1/2 flex flex-col items-center justify-center px-10 space-y-8 py-12">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-n-text-green">
            Recuperar senha
          </h1>
          <p className="text-md md:text-lg text-center text-n-text-neutral max-w-md">
            Verifique a caixa de entrada e de spam no seu e‑mail, e informe o
            código de verificação enviado.
          </p>

          <form
            onSubmit={handleSubmit}
            className="w-full flex flex-col gap-6 max-w-xl"
          >
            <Input
              type="text"
              placeholder="Código de verificação"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              className="w-full h-14 text-base px-6 rounded-xl border border-n-neutral-lighter bg-white"
            />
            <div className="flex justify-end w-full">
              <Button
                type="submit"
                disabled={loading}
                className="w-full md:w-[250px] h-12 rounded-full bg-n-green-action hover:brightness-95 text-n-text-green text-base font-semibold"
              >
                {loading ? (
                  <>
                    Verificando...
                    <Loader2 size={20} className="ml-3 animate-spin" />
                  </>
                ) : (
                  <>
                    Prosseguir
                    <ArrowRight size={20} className="ml-3" />
                  </>
                )}
              </Button>
            </div>
          </form>
        </div>

        <div className="w-full md:w-1/2 flex items-center justify-center">
          <ImageSvg
            src={"concept-company.svg"}
            alt="Verificar Codigo"
            className="w-[320px] md:w-[600px] max-w-full"
          />
        </div>
      </div>
    </div>
  );
}
